import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'maplibre-gl/dist/maplibre-gl.css';
import 'leaflet/dist/leaflet.css';
import { useDataFromS3 } from '../hooks/useDataFromS3';
import Grid from '@mui/material/Grid2';
import { Stack, Box, Typography } from '@mui/material';
import MapBsnTelAverage from '../components/map_bsn_tel_average';
import VerticalBar from '../components/vertical_bar'
import RiverRisk from '../components/river_risk';
import '../style/legend_risk.css';
import { RIVER_BSN_TEL_LEGEND } from '../const/legend'
import { TEL_RISK_LEVEL_POINT } from '../const/color'
import CommonCard from '../item/common_card';
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
import { setTelRiskColor } from '../func/color';
import { 
    getAllMtrDateTime, getMaxByDateTimeApiData, getTimeAry, getTelTimeAry,
    getMaxH1OfByCode, getAllByCode, getRankBsn, getTelIsCurrentVal, getMaxListTel
} from '../func/util'
import { GRID_RANK } from '../const/grid'
import choropleth_tel from '../data/tel.json';
import choropleth_bsn from '../data/bsn.json';

const River = (props) => {
    const [bsnAverageDatetime, setBsnAverageDatetime] = useState([]);
    const [bsnAverageH24Datetime, setBsnAverageH24Datetime] = useState([]);
    const [floodMaxMtrDatetime, setFloodMaxMtrDatetime] = useState([]);
    const [bsnH1Of, setBsnH1Of] = useState(null);
    const [telDataLatestVal, setTelDataLatestVal] = useState(null);
    const [telDateArray, setTelDateArray] = useState([]);
    const [dateArray, setDateArray] = useState([]);
    const [telRiskAllRankData, setTelRiskAllRankData] = useState([]);
    const [maxValInfo, setMaxValInfo] = useState(null);
    const [shouldFetchMain, setShouldFetchMain] = useState(false);
    const [shouldFetchTel, setShouldFetchTel] = useState(false);
    const location = useLocation();
    const prevDataARef = useRef(null);
    const prevTelDatetimeRef = useRef(null);

    const { data, isLoading, error } = useDataFromS3(`api/get_datetime_latest`);

    // 10分おきの水位計の時刻を取得
    const {
        data: telDatetimeLatest,
    } = useDataFromS3(`api/get_tel_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (data && JSON.stringify(data) !== JSON.stringify(prevDataARef.current)) {
            prevDataARef.current = data;
            setShouldFetchMain(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchMain(false); // dataが変わってないならメインデータを取得しない
        }
    }, [data]);

    useEffect(() => {
        if (telDatetimeLatest && JSON.stringify(telDatetimeLatest) !== JSON.stringify(prevTelDatetimeRef.current)) {
            prevTelDatetimeRef.current = telDatetimeLatest;
            setShouldFetchTel(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchTel(false); // dataが変わってないならメインデータを取得しない
        }
    }, [telDatetimeLatest]);

    let tel_url = null
    let bsn_of_url = null
    if (shouldFetchMain && shouldFetchTel) {
        bsn_of_url = `api/get_bsn_of`
    }

    if (shouldFetchTel) {
        tel_url = `api/get_tel_mtr`
    }

    useEffect(() => {
        prevDataARef.current = null
        prevTelDatetimeRef.current = null
    }, [location.pathname])

    // 水位計データを取得
    const {
        data: telData,
        loading: telLoading,
        error: telError,
    } = useDataFromS3(tel_url);

    // 流域平均流出量を取得
    const {
        data: bsnOfData,
        loading: bsnOfLoading,
        error: bsnOfError,
    } = useDataFromS3(bsn_of_url);

    const getRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.risk_val === b.risk_val) {
                    return a.pct_val - b.pct_val;
                }
                return a.risk_val - b.risk_val
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => b.risk_val - a.risk_val)
            rankData.sort((a, b) => {
                if (a.risk_val === b.risk_val) {
                    return b.pct_val - a.pct_val;
                }
                return b.risk_val - a.risk_val
            })
        }

        // tooltip用
        const tempAreaNameAry = [];
        const tempAreaRiverNameAry = [];

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: getYValue(rankData[i].pct_val),
                        custom: {
                            name: rankData[i].name,
                            txt_river_name: rankData[i].txt_river_name,
                            tel_code: rankData[i].code,
                            area_lng: rankData[i].lng,
                            area_lat: rankData[i].lat,
                            tel_risk: rankData[i].risk_val,
                            labelValue: getLabelValue(rankData[i].pct_val)
                        }
                    })
                    category_ary.push(`${rankData[i].name}（${rankData[i].txt_river_name}）`);
                    tempAreaNameAry.push(rankData[i].name);
                    tempAreaRiverNameAry.push(rankData[i].txt_river_name);
                }
            }
        } else {
            rankData.map(item => {
                series_ary.push({
                    x: '',
                    y: getYValue(item.pct_val),
                    custom: {
                        name: item.name,
                        txt_river_name: item.txt_river_name,
                        tel_code: item.code,
                        area_lng: item.lng,
                        area_lat: item.lat,
                        tel_risk: item.risk_val,
                        labelValue: getLabelValue(item.pct_val)
                    }
                })
                category_ary.push(`${item.name}（${item.txt_river_name}）`);
                tempAreaNameAry.push(item.name);
                tempAreaRiverNameAry.push(item.txt_river_name);
            })
        }
        return { rankData, series_ary, category_ary, tempAreaNameAry, tempAreaRiverNameAry };
    }

    // ランキングクリック時の動作
    const verticalBarClickEvent = (clickedItem) => {
        props.setSelectTelCode([clickedItem.custom.tel_code])
    }

    // ランキングのカラー
    const getRankColor = (value, series, seriesIndex, dataPointIndex, w) => {
        return setTelRiskColor(series[seriesIndex].data[dataPointIndex]?.custom.tel_risk)
    }

    // ランキングのフォーマット
    const getFormat = (val, opts) => {
        const customData = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex]?.custom;
        return customData?.labelValue ?? '';
    }

    const toZenkakuAll = (str) => {
        return str
            .replace(/[0-9A-Za-z]/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFEE0)) // 半角英数字 → 全角
            .replace(/,/g, '、')         // 半角カンマ → 全角カンマ
            .replace(/ /g, '　')         // 半角スペース → 全角スペース
            .replace(/\(/g, '（')        // 半角( → 全角（
            .replace(/\)/g, '）');       // 半角) → 全角）
    };

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        let str = toZenkakuAll(String(value));
        // 8文字以上は省略
        if (str.length >= 8) {
            return str = str.slice(0, 3) + '…' + str.slice(-4);
        }
        return '　'.repeat(8 - str.length) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].custom.txt_river_name;
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts, areaNameAry, areaRiverNameAry) => {
        const label = areaNameAry[opts.dataPointIndex]; // y軸ラベル（水位計名）
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]; // 値
        const riverNameLabel = areaRiverNameAry[opts.dataPointIndex];

        return `
            <div style="padding: 4px 8px; font-size: 12px;">
                ${label} （${riverNameLabel}）: ${value}
            </div>
        `;
    }   

    // ローディング開始
    const startLoading = () => {
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
    }

    useEffect(() => {
        startLoading()
        const fetchData = async () => {
            let tel_risk_rank = []
            let date_ary = []
            let tel_date_ary = []
            let mtr_max_datetime = []
            let bsn_average_datetime = []
            let bsn_h24_average_datetime = []
            let bsn_h1_of_all_datetime = []
            let bsn_h1_of_max = []
            let tel_data_latest = []
            let tel_code_ary = []
            let bsn_code_ary = []
            let features_bsn = []
            let features_tel = []
            let masterBsnFeatures = []
            let masterTelFeatures = []

            if (props.selectBsn && Array.isArray(props.selectBsn)
                && props.selectBsn.length > 0) {
                features_tel = choropleth_tel.features
                // telデータ取得
                masterTelFeatures = features_tel.filter(f =>
                    props.selectBsn.includes(f.properties['bsn_code'])
                );

                // bsnデータの properties.id を配列で取得(これが対象のbsnコード)
                bsn_code_ary = props.selectBsn;
                // telデータの properties.id を配列で取得(これが対象のtelコード)
                tel_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties.tel_code))];
            } else if (props.selectTelCode && Array.isArray(props.selectTelCode)
                && props.selectTelCode.length > 0) {
                features_tel = choropleth_tel.features
                // telデータ取得
                masterTelFeatures = features_tel.filter(f =>
                    props.selectTelCode.includes(f.properties['tel_code'])
                );

                // bsnデータの properties.id を配列で取得(これが対象のbsnコード)
                bsn_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties.bsn_code))];
                // telデータの properties.id を配列で取得(これが対象のtelコード)
                tel_code_ary = props.selectTelCode;
            } else {
                features_bsn = choropleth_bsn.features
                features_tel = choropleth_tel.features
                // bsnデータ取得
                masterBsnFeatures = features_bsn.filter(f =>
                    props.selectCitys.includes(f.properties['city_code']?.toString())
                );
                // telデータ取得
                masterTelFeatures = features_tel.filter(f =>
                    props.selectCitys.includes(f.properties['city_code']?.toString())
                );

                // bsnデータの properties.bsn_code を配列で取得(これが対象のbsnコード)
                bsn_code_ary = [...new Set(masterBsnFeatures.map(feature => feature.properties.bsn_code))];
                // telデータの properties.id を配列で取得(これが対象のtelコード)
                tel_code_ary = [...new Set(masterTelFeatures.map(feature => feature.properties.tel_code))];
            }
            // 時刻の断面を取得
            date_ary = getTimeAry(data, props.h6Switch)
            // 10分おきの水位計の時刻の断面を取得
            tel_date_ary = getTelTimeAry(telDatetimeLatest)
            // 河川
            bsn_h1_of_all_datetime = getAllByCode(bsn_code_ary, bsnOfData, props.h6Switch)
            // 水位計
            let telArray = getTelIsCurrentVal(tel_code_ary, telData)
            if (telArray.length > 0) {
                tel_data_latest = getMaxListTel(telArray, 0);
            }
            if (bsn_h1_of_all_datetime.length > 0) {
                // 流域平均1時間雨量を取得
                bsn_h1_of_max = getMaxH1OfByCode(bsn_h1_of_all_datetime, 0)
            }
            // 水位％のランキングを取得
            tel_risk_rank = getRankBsn(tel_code_ary, masterTelFeatures, telData, 'risk_val', 'pct_val', 200);
            // 水位％のランキングが取得できない場合
            if (tel_risk_rank && tel_risk_rank.length > 0) {
                // 最大値でオブジェクト作成
                setMaxValInfo({
                    name: tel_risk_rank[tel_risk_rank.length - 1].name,
                    txt_river_name: tel_risk_rank[tel_risk_rank.length - 1].txt_river_name,
                    riskMax: tel_risk_rank[tel_risk_rank.length - 1].risk_val,
                    pctMax: tel_risk_rank[tel_risk_rank.length - 1].pct_val,
                    mtrMax: tel_risk_rank[tel_risk_rank.length - 1].mtr_val,
                    tel_code: tel_risk_rank[tel_risk_rank.length - 1].code,
                    borderPurpleMax: tel_risk_rank[tel_risk_rank.length - 1].border_purple,
                    borderRedMax: tel_risk_rank[tel_risk_rank.length - 1].border_red,
                    borderYellowMax: tel_risk_rank[tel_risk_rank.length - 1].border_yellow,
                    borderGreenMax: tel_risk_rank[tel_risk_rank.length - 1].border_green
                })
            }

            if (tel_risk_rank != null
                && tel_risk_rank != undefined
                && Array.isArray(tel_risk_rank)
                && tel_risk_rank.length > 0
            ) {
                if (props.selectTelCode.length > 0) {
                    let target = [];
                    for (let i = 0; i < props.selectTelCode.length; i++) {
                        target = tel_risk_rank.find(item => item.code === Number(props.selectTelCode[i]));

                        setMaxValInfo({
                            name: target.name,
                            txt_river_name: target.txt_river_name,
                            riskMax: target.risk_val,
                            pctMax: target.pct_val,
                            mtrMax: target.mtr_val,
                            tel_code: target.code,
                            borderPurpleMax: target.border_purple,
                            borderRedMax: target.border_red,
                            borderYellowMax: target.border_yellow,
                            borderGreenMax: target.border_green
                        })
                    }
                }
            }

            if (tel_risk_rank.length > 0) {
                // 10分おきの水位を取得
                const telData_by_bsn = getAllByCode([tel_risk_rank[tel_risk_rank.length - 1].code], telData, false)
                mtr_max_datetime = getAllMtrDateTime(telData_by_bsn[0], tel_date_ary.length)
            }

            // 流域平均流出量を取得
            bsn_average_datetime = getMaxByDateTimeApiData(bsn_code_ary, bsnOfData, 'of_val', props.h6Switch)
            // 流域平均24時間雨量を取得
            bsn_h24_average_datetime = getMaxByDateTimeApiData(bsn_code_ary, bsnOfData, 'h24_val', props.h6Switch);
            // 水位％のランキング
            setTelRiskAllRankData(tel_risk_rank)
            // 河川データ
            setBsnH1Of(bsn_h1_of_max.length > 0 ? bsn_h1_of_max : null)
            // 水位計データ
            setTelDataLatestVal(tel_data_latest.length > 0 ? tel_data_latest : null)
            // 1時間ごとの時刻断面
            setDateArray(date_ary)
            // 10分ごとの時刻断面
            setTelDateArray(tel_date_ary)
            // 10分おきの水位を取得
            setFloodMaxMtrDatetime(mtr_max_datetime);
            // 流域平均流出量
            setBsnAverageDatetime(bsn_average_datetime.length > 0 ? bsn_average_datetime : null)
            // 流域平均24時間雨量
            setBsnAverageH24Datetime(bsn_h24_average_datetime.length > 0 ? bsn_h24_average_datetime : null)
        };

        if (data && telData && telDatetimeLatest && bsnOfData) {
            fetchData();
        }
    }, [data,
        telDatetimeLatest,
        telData,
        bsnOfData,
        props.selectCitys, props.selectBsn, props.selectTelCode, props.h6Switch
    ]);

    if (isLoading || data === undefined
        || (error && error.message.includes("Received HTML"))
        || telLoading || telData === undefined
        || (telError && telError.message.includes("Received HTML"))
        || bsnOfLoading || bsnOfData === undefined
        || (bsnOfError && bsnOfError.message.includes("Received HTML"))
    ) {
        // Loading表示
        return <Proggress />
    }

    if (error
        || telError
        || bsnOfError
    ) {
        return (
            <>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white'
                    }}
                >
                    申し訳ございません、データ取得に失敗しました。
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white'
                    }}
                >
                    恐れ入りますが、しばらく時間をおいてから再度お試しください。
                </Typography>
            </>
        )
    }

    return (
        <>
            <Box
                sx={{
                    // グローバルヘッダーの「36px」と時刻表示分の「17px」、大枠のGridのマージン上下「8px」ずつを差し引きく
                    height: { xs: '100%', sm: 'calc(100dvh - 36px - 17px - 8px - 8px)' }, // 親が高さを持つ
                    boxSizing: 'border-box',
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    dateTime={data && data[12]}
                />
                <Grid container
                    spacing={0}
                    columns={12}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0, overflow: 'hidden' }} // Grid全体の高さ100%
                >
                    <Grid size={{ xs: 12, sm: 7, md: 4 }}>
                        <CommonCard
                            child={
                                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Box sx={{ flex: 1, minHeight: 0 }}>
                                        <MapBsnTelAverage
                                            selectTelCode={props.selectTelCode}
                                            setSelectTelCode={props.setSelectTelCode}
                                            selectBsn={props.selectBsn}
                                            setSelectBsn={props.setSelectBsn}
                                            selectCitys={props.selectCitys}
                                            bsnData={bsnH1Of}
                                            telData={telDataLatestVal}
                                            bsnMapZoom={props.bsnMapZoom}
                                            bsnMapCenter={props.bsnMapCenter}
                                            setReady={props.setReady}
                                            label={'流域平均流出量'}
                                        />
                                    </Box>
                                    <Box sx={{ mt: 0.5 }}>
                                        {RIVER_BSN_TEL_LEGEND()}
                                    </Box>
                                </Box>
                            }
                            title={"水位と流域平均流出量"}
                            xsHeight="400px"
                            height='calc(100dvh - (36px * 1.0) - (17px * 1.0) - (8px * 1.0) - (8px * 1.0) - 31px)'
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 5, md: 3.5 }}>
                        <Stack spacing={0} height={{ xs: '100%', sm: 'calc(100dvh - (36px * 1.0) - (17px * 1.0))' }} >
                            {/* 避難推奨レベル（河川）ランキング */}
                            <CommonCard
                                child={
                                    <>
                                        <VerticalBar
                                            distance={35}
                                            limitVal={100}
                                            grid={GRID_RANK}
                                            allRankData={telRiskAllRankData}
                                            dateArray={dateArray}
                                            getRankData={getRankData}
                                            plusValue={10}
                                            verticalBarClickEvent={verticalBarClickEvent}
                                            getRankColor={getRankColor}
                                            fontSize={'8px'}
                                            getFormat={getFormat}
                                            maxWidth={180}
                                            getLabelFormat={getLabelFormat}
                                            enabled={true}
                                            tooltipFormatX={tooltipFormatX}
                                            tooltipFormatY={tooltipFormatY}
                                            tooltipFormatCustom={tooltipFormatCustom}
                                            height={'100%'}
                                            isReadyKey={['rank_river']}
                                            isReadyFlg={props.isReady.rank_river}
                                            setReady={props.setReady}
                                        />
                                    </>
                                }
                                title={"水位パーセントランキング"}
                                xsHeight="500px"
                                height='calc(100dvh - (36px * 1.0) - (17px * 1.0) - (8px * 1.0) - (8px * 1.0) - 31px - 5px)'
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 4.5 }}>
                        <CommonCard
                            child={
                                <>
                                    <Box border={1} borderColor="white" pb={1} pr={1} sx={{ boxSizing: 'border-box', height: '100%' }}>
                                        <RiverRisk
                                            selectTelCode={props.selectTelCode}
                                            selectCitys={props.selectCitys}
                                            limitVal={15}
                                            setColor={setTelRiskColor}
                                            allRankData={telRiskAllRankData}
                                            maxValInfo={maxValInfo}
                                            maxMtrDatetime={floodMaxMtrDatetime}
                                            bsnAverageDatetime={bsnAverageDatetime}
                                            bsnAverageH24Datetime={bsnAverageH24Datetime}
                                            isReadyLineKey={['line_river']}
                                            isReadyBarLineKey={['bar_line_river']}
                                            isReadyLineFlg={props.isReady.line_river}
                                            isReadyBarLineFlg={props.isReady.bar_line_river}
                                            setReady={props.setReady}
                                            levelPoint={TEL_RISK_LEVEL_POINT}
                                            dateArray={dateArray}
                                            telDateArray={telDateArray}
                                            h6Switch={props.h6Switch}
                                        />
                                    </Box>
                                </>
                            }
                            xsHeight="1000px"
                            height='calc(100dvh - (36px * 1.0) - (17px * 1.0) - (8px * 1.0) - (8px * 1.0) - 31px - 5px)'
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default River;